//shuffle letterrrrsss ://
/*!
 * shuffle-letters
 * A JavaScript library to shuffle the text content of a DOM element with an animated effect.
 *
 * @version v1.1.0
 * @author George Raptis <georapbox@gmail.com>
 * @homepage https://github.com/georapbox/shuffle-letters#readme
 * @repository git+https://github.com/georapbox/shuffle-letters.git
 * @license MIT
 */ function $30327a5957424267$var$t(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
    }
    return r;
}
function $30327a5957424267$var$e(e) {
    for(var n = 1; n < arguments.length; n++){
        var o = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $30327a5957424267$var$t(Object(o), !0).forEach(function(t) {
            $30327a5957424267$var$r(e, t, o[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : $30327a5957424267$var$t(Object(o)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
        });
    }
    return e;
}
function $30327a5957424267$var$r(t, e, r) {
    return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = r, t;
}
function $30327a5957424267$var$n(t) {
    return function(t) {
        if (Array.isArray(t)) return $30327a5957424267$var$o(t);
    }(t) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(t) || function(t, e) {
        if (!t) return;
        if ("string" == typeof t) return $30327a5957424267$var$o(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $30327a5957424267$var$o(t, e);
    }(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $30327a5957424267$var$o(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
    return n;
}
function $30327a5957424267$var$i(t) {
    var e = "";
    switch(t){
        case "lowerCase":
            e = "abcdefghijklmnopqrstuvwxyz";
            break;
        case "upperCase":
            e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            break;
        case "digit":
            e = "0123456789";
            break;
        case "symbol":
            e = ",.?/\\(^)![]{}*&^%$#'\"";
    }
    var r = e.split("");
    return r[Math.floor(Math.random() * r.length)];
}
function $30327a5957424267$var$a(t) {
    return !!t && 1 === t.nodeType && t instanceof Element == !0;
}
function $30327a5957424267$var$c(t) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = {
        text: "",
        iterations: 8,
        fps: 30,
        onComplete: function() {}
    }, c = $30327a5957424267$var$e($30327a5957424267$var$e({}, o), r);
    if (!$30327a5957424267$var$a(t)) throw new TypeError("Expected element to be a valid HTML element.");
    for(var u = c.text && "string" == typeof c.text ? c.text.split("") : t.textContent.split(""), l = [], f = [], s = 0; s < u.length; s += 1){
        var p = u[s];
        /\s/.test(p) ? l[s] = "space" : (/[a-z]/.test(p) ? l[s] = "lowerCase" : /[A-Z]/.test(p) ? l[s] = "upperCase" : /[0-9]/.test(p) ? l[s] = "digit" : l[s] = "symbol", f.push(s));
    }
    t.textContent = "";
    var b = null;
    return function e(r) {
        var o = $30327a5957424267$var$n(u), a = f.length;
        if (r > a) "function" == typeof c.onComplete && c.onComplete(t);
        else {
            for(var s = Math.max(r, 0); s < a; s += 1)s < r + c.iterations ? o[f[s]] = $30327a5957424267$var$i(l[f[s]]) : o[f[s]] = "";
            t.textContent = o.join(""), b = setTimeout(function() {
                e(r + 1);
            }, 1e3 / c.fps);
        }
    }(-c.iterations), function() {
        clearTimeout(b), b = null;
    };
}
var $30327a5957424267$export$2e2bcd8739ae039 = $30327a5957424267$var$c;


var $54b47fc030b7b21e$var$categories = document.querySelectorAll(".category-project");
// Désactive l'effet sous 767px
const $54b47fc030b7b21e$var$allowShuffle = window.innerWidth >= 767;
$54b47fc030b7b21e$var$categories.forEach((category)=>{
    let isAnimating = false;
    let canAnimate = true;
    category.addEventListener("mouseenter", ()=>{
        if (!$54b47fc030b7b21e$var$allowShuffle) return;
        if (!isAnimating && canAnimate) {
            isAnimating = true;
            canAnimate = false;
            let projectName = category.querySelector(".project-name");
            if (projectName) (0, $30327a5957424267$export$2e2bcd8739ae039)(projectName, {
                iterations: 4,
                fps: 40
            });
            setTimeout(()=>{
                isAnimating = false;
            }, 800);
        }
    });
    category.addEventListener("mouseleave", ()=>{
        if (!$54b47fc030b7b21e$var$allowShuffle) return;
        setTimeout(()=>{
            canAnimate = true;
        }, 100);
    });
});
//ANIMATION ACCUEIL
//ANIMATION PERSO ACCUEIL
document.addEventListener("DOMContentLoaded", ()=>{
    const personnage = document.querySelector(".home-personnage");
    const container = document.querySelector(".welcome");
    let progress = 0;
    let targetProgress = 0;
    const distancePercent = 30; // le personnage se déplace sur 80% de la largeur de l'écran
    // écoute la molette
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 1300;
        targetProgress += e.deltaY / sensitivity;
        targetProgress = Math.max(0, Math.min(1, targetProgress));
    }, {
        passive: true
    });
    function tick() {
        // mise à jour de progress
        progress += (targetProgress - progress) * 0.1;
        // calcule la distance réelle en pixels
        const distancePx = distancePercent / 100 * window.innerWidth;
        // applique le mouvement
        gsap.set(personnage, {
            y: distancePx * progress
        });
        // disparition / réapparition
        if (progress >= 0.99) personnage.style.display = "none";
        else if (personnage.style.display === "none") personnage.style.display = "";
        requestAnimationFrame(tick);
    }
    tick();
});
//ANIMATION PORTFOLIO ACCUEIL
document.addEventListener("DOMContentLoaded", ()=>{
    const portfolioText = document.querySelector(".portfolio-text");
    const container = document.querySelector(".welcome");
    let progress = 0;
    let targetProgress = 0;
    const distancePercent = -30; // le personnage se déplace sur 80% de la largeur de l'écran
    // écoute la molette
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 1300;
        targetProgress += e.deltaY / sensitivity;
        targetProgress = Math.max(0, Math.min(1, targetProgress));
    }, {
        passive: true
    });
    function tick() {
        // mise à jour de progress
        progress += (targetProgress - progress) * 0.1;
        // calcule la distance réelle en pixels
        const distancePx = distancePercent / 100 * window.innerWidth;
        // applique le mouvement
        gsap.set(portfolioText, {
            y: distancePx * progress
        });
        // disparition / réapparition
        if (progress >= 0.99) portfolioText.style.display = "none";
        else if (portfolioText.style.display === "none") portfolioText.style.display = "";
        requestAnimationFrame(tick);
    }
    tick();
});
//ANIMATION LOGO ACCUEIL
document.addEventListener("DOMContentLoaded", ()=>{
    const logo = document.querySelector(".logo");
    const container = document.querySelector(".welcome");
    let progress = 0;
    let targetProgress = 0;
    const distancePercent = 30; // le personnage se déplace sur 80% de la largeur de l'écran
    // écoute la molette
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 1300;
        targetProgress += e.deltaY / sensitivity;
        targetProgress = Math.max(0, Math.min(1, targetProgress));
    }, {
        passive: true
    });
    function tick() {
        // mise à jour de progress
        progress += (targetProgress - progress) * 0.1;
        // calcule la distance réelle en pixels
        const distancePx = distancePercent / 100 * window.innerWidth;
        // applique le mouvement
        gsap.set(logo, {
            x: distancePx * progress
        });
        // disparition / réapparition
        if (progress >= 0.99) logo.style.display = "none";
        else if (logo.style.display === "none") logo.style.display = "";
        requestAnimationFrame(tick);
    }
    tick();
});
//ANIMATION CHARLOT KOLLY ACCUEIL
document.addEventListener("DOMContentLoaded", ()=>{
    const homeCharlotKolly = document.querySelector(".home-charlot-kolly");
    const container = document.querySelector(".welcome");
    let progress = 0;
    let targetProgress = 0;
    const distancePercent = -40; // le personnage se déplace sur 80% de la largeur de l'écran
    // écoute la molette
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 1300;
        targetProgress += e.deltaY / sensitivity;
        targetProgress = Math.max(0, Math.min(1, targetProgress));
    }, {
        passive: true
    });
    function tick() {
        // mise à jour de progress
        progress += (targetProgress - progress) * 0.1;
        // calcule la distance réelle en pixels
        const distancePx = distancePercent / 100 * window.innerWidth;
        // applique le mouvement
        gsap.set(homeCharlotKolly, {
            x: distancePx * progress
        });
        // disparition / réapparition
        if (progress >= 0.99) homeCharlotKolly.style.display = "none";
        else if (homeCharlotKolly.style.display === "none") homeCharlotKolly.style.display = "";
        requestAnimationFrame(tick);
    }
    tick();
});
//ANIMATION LIGHT AND LAMP
//TRANSLATE
document.addEventListener("DOMContentLoaded", ()=>{
    const lamp = document.querySelector(".light-and-lamp");
    const container = document.querySelector(".welcome");
    let progress = 0;
    let targetProgress = 0;
    // Valeurs séparées
    const moveTopPercent = 7; // ex: -8% sur l'axe Y
    const moveRightPercent = 5; // ex: -12% sur l'axe X
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 400;
        targetProgress += e.deltaY / sensitivity;
        targetProgress = Math.max(0, Math.min(1, targetProgress));
    }, {
        passive: true
    });
    function tick() {
        progress += (targetProgress - progress) * 0.1;
        lamp.style.top = `${-moveTopPercent * progress}%`;
        lamp.style.right = `${-moveRightPercent * progress}%`;
        requestAnimationFrame(tick);
    }
    tick();
});
//ROTATE LAMP
document.addEventListener("DOMContentLoaded", ()=>{
    const lamp = document.querySelector(".home-lamp");
    const container = document.querySelector(".welcome");
    let progressLamp = 0; // valeur actuelle
    let targetProgressLamp = 0; // valeur cible
    const rotateAngle = 13; // angle final en degrés
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 400; // ajuste la vitesse
        targetProgressLamp += e.deltaY / sensitivity;
        targetProgressLamp = Math.max(0, Math.min(1, targetProgressLamp));
    }, {
        passive: true
    });
    function tickLamp() {
        // interpolation douce
        progressLamp += (targetProgressLamp - progressLamp) * 0.1;
        // applique la rotation
        gsap.set(lamp, {
            rotate: rotateAngle * progressLamp
        });
        // disparition/réapparition si tu veux
        // if (progressLamp >= 1) lamp.style.display = "none";
        // else if (lamp.style.display === "none") lamp.style.display = "";
        requestAnimationFrame(tickLamp);
    }
    tickLamp();
});
//ROTATE LIGHT
document.addEventListener("DOMContentLoaded", ()=>{
    const light = document.querySelector(".home-light");
    const container = document.querySelector(".welcome");
    let progressLight = 0; // valeur actuelle
    let targetProgressLight = 0; // valeur cible
    const rotateAngle = 13; // angle final en degrés
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 400; // ajuste la vitesse
        targetProgressLight += e.deltaY / sensitivity;
        targetProgressLight = Math.max(0, Math.min(1, targetProgressLight));
    }, {
        passive: true
    });
    function tickLight() {
        // interpolation douce
        progressLight += (targetProgressLight - progressLight) * 0.1;
        // applique la rotation
        gsap.set(light, {
            rotate: rotateAngle * progressLight
        });
        // disparition/réapparition si tu veux
        // if (progressLamp >= 1) lamp.style.display = "none";
        // else if (lamp.style.display === "none") lamp.style.display = "";
        requestAnimationFrame(tickLight);
    }
    tickLight();
});
//OPACITE QUI DISPARRAIT ACCUEIL FOND
document.addEventListener("DOMContentLoaded", ()=>{
    const container = document.querySelector(".welcome");
    const cover = document.querySelector(".cover-home-image");
    const grain = document.querySelector(".texture-grain");
    const black = document.querySelector(".black-fill");
    let progress = 0;
    let targetProgress = 0;
    container.addEventListener("wheel", (e)=>{
        if (e.target.closest(".projects-list")) return;
        const sensitivity = 400; // augmente pour rendre le scroll moins sensible
        targetProgress += e.deltaY / sensitivity;
        targetProgress = Math.max(0, Math.min(1, targetProgress));
    }, {
        passive: true
    });
    function tick() {
        // interpolation fluide
        progress += (targetProgress - progress) * 0.1;
        // opacité qui va de 1 à 0 selon le scroll
        const opacity = 1 - progress;
        cover.style.opacity = opacity;
        grain.style.opacity = opacity;
        black.style.opacity = opacity;
        requestAnimationFrame(tick);
    }
    tick();
});
//EMPECHER LA PAGE DE SCROLLER QUAND ON EST SUR PROJECTS LIST
const $54b47fc030b7b21e$var$list = document.querySelector(".projects-list");
// désactive tous les ScrollTriggers
function $54b47fc030b7b21e$var$disableScrollTriggers() {
    gsap.utils.toArray(ScrollTrigger.getAll()).forEach((trigger)=>{
        trigger.disable(false); // false = ne pas réinitialiser
    });
}
// réactive tous les ScrollTriggers
function $54b47fc030b7b21e$var$enableScrollTriggers() {
    gsap.utils.toArray(ScrollTrigger.getAll()).forEach((trigger)=>{
        trigger.enable(false);
    });
}
$54b47fc030b7b21e$var$list.addEventListener("pointerenter", ()=>{
    $54b47fc030b7b21e$var$disableScrollTriggers();
});
$54b47fc030b7b21e$var$list.addEventListener("pointerleave", ()=>{
    $54b47fc030b7b21e$var$enableScrollTriggers();
});
// BURGER MENU
const $54b47fc030b7b21e$var$burger = document.querySelector(".burger-menu");
const $54b47fc030b7b21e$var$navigation = document.querySelector(".navigation");
$54b47fc030b7b21e$var$burger.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$navigation.classList.toggle("is-active");
});
const [$54b47fc030b7b21e$var$openIcon, $54b47fc030b7b21e$var$closeIcon] = $54b47fc030b7b21e$var$burger.querySelectorAll("img");
$54b47fc030b7b21e$var$burger.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$openIcon.classList.toggle("is-not-active");
    $54b47fc030b7b21e$var$closeIcon.classList.toggle("is-not-active");
});


//# sourceMappingURL=index.faf03d6a.js.map
